import { render, staticRenderFns } from "./maintenance-regime-weightage.vue?vue&type=template&id=145937eb&"
import script from "./maintenance-regime-weightage.vue?vue&type=script&lang=js&"
export * from "./maintenance-regime-weightage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports